import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import {
  IOwnerCreateCardReq,
  IOwnerCreateCardResp,
  IGetOwnerCreateCardDetailReq,
  IGetOwnerCreateCardDetailResp,
} from '../types/collection';

export const postOwnerCreateCard = async (
  data: IOwnerCreateCardReq,
  config?: AxiosRequestConfig
): Promise<IOwnerCreateCardResp> => {
  const url = '/weaver/api/v1/collection/card/owner_create';
  return request.post(url, data, config || {});
};

export const postGetOwnerCreateCardDetail = async (
  data: IGetOwnerCreateCardDetailReq,
  config?: AxiosRequestConfig
): Promise<IGetOwnerCreateCardDetailResp> => {
  const url = '/weaver/api/v1/collection/card/get_owner_create_card_detail';
  return request.post(url, data, config || {});
};
